import { Component, OnInit, OnDestroy } from '@angular/core';
import { ListsService } from 'src/app/services/lists.service';

@Component({
  selector: 'app-my-portfolio',
  templateUrl: './my-portfolio.component.html',
  styleUrls: ['./my-portfolio.component.scss']
})
export class MyPortfolioComponent implements OnInit {

  selectedCluster: number;

  selectBlock: string = '';
  panelOpenState = false;

  constructor(private listsService: ListsService) {
    this.listsService.loadLists();
  }

  ngOnInit(): void {
  }

}
